import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/(other)/auth/signup/components/signupForm.tsx");
